import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Check, ArrowRight } from "lucide-react";

const STEPS = [
  { key: "asesmen", label: "Asesmen" },
  { key: "profil", label: "Profil" },
  { key: "jelajahi", label: "Jelajahi Bidang" },
  { key: "susun", label: "Susun Langkah" },
  { key: "tryout", label: "TryOut" },
  { key: "info", label: "Info Jalur", optional: true },
];

export function JourneyPosition({ current, note }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/dashboard/overview").then((r) => setData(r.data)).catch(() => {}); }, []);

  const done = {
    asesmen: !!data?.assessment,
    profil: !!data?.assessment,
    jelajahi: !!data?.journey?.bidang_minat,
    susun: !!(data?.journey?.rencana?.length || data?.journey?.mapel_pilihan?.length),
    tryout: data?.tryout_count > 0,
    info: false,
  };

  return (
    <div className="clay-card p-6 mb-8" data-testid="journey-position">
      <p className="text-xs font-semibold text-[#5C5F5C] mb-3">Perjalananmu</p>
      <div className="flex items-center gap-1.5 flex-wrap">
        {STEPS.map((s, i, arr) => {
          const isCurrent = s.key === current;
          const isDone = !isCurrent && done[s.key];
          return (
            <div key={s.key} className="flex items-center gap-1.5">
              <span data-testid={`pos-step-${i}`}
                className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium ${
                  isCurrent ? "bg-[#E25E3E] text-white ring-2 ring-[#E25E3E]/30"
                  : isDone ? "bg-[#4A6B53]/10 text-[#4A6B53]"
                  : "bg-[#F0ECE4] text-[#8a8d8a]"}`}>
                {isDone && <Check className="h-3.5 w-3.5" />}
                {s.label}
              </span>
              {i < arr.length - 1 && <ArrowRight className="h-3.5 w-3.5 text-[#C9C4BC]" />}
            </div>
          );
        })}
      </div>
      {note && <div className="mt-4 rounded-xl bg-[#F4B942]/10 border border-[#F4B942]/30 p-4">{note}</div>}
    </div>
  );
}

export default JourneyPosition;
